import { colors } from "../../Styles";

export function Excel({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <g transform="matrix(1,0,0,1,-4.75625,-0.25)">
        <path d="M79,31L245,31L245,252L78,252L78,184.25L61,184.25L61,271L263,271L263,13L60,13L60,60L79,60L79,31Z"/>
      </g>
      <g transform="matrix(1,0,0,1,82.9028,53)">
        <rect x="114.792" y="171.079" width="32.194" height="17.596"/>
      </g>
      <g transform="matrix(1,0,0,1,40.9028,53)">
        <rect x="114.792" y="171.079" width="32.194" height="17.596"/>
      </g>
      <g transform="matrix(1,0,0,1,40.9028,26)">
        <rect x="114.792" y="171.079" width="32.194" height="17.596"/>
      </g>
      <g transform="matrix(1,0,0,1,82.9028,26)">
        <rect x="114.792" y="171.079" width="32.194" height="17.596"/>
      </g>
      <g transform="matrix(1,0,0,1,82.9028,-2)">
        <rect x="114.792" y="171.079" width="32.194" height="17.596"/>
      </g>
      <g transform="matrix(1,0,0,1,40.9028,-2)">
        <rect x="114.792" y="171.079" width="32.194" height="17.596"/>
      </g>
      <g transform="matrix(1,0,0,1,40.9028,-29)">
        <rect x="114.792" y="171.079" width="32.194" height="17.596"/>
      </g>
      <g transform="matrix(1,0,0,1,82.9028,-29)">
        <rect x="114.792" y="171.079" width="32.194" height="17.596"/>
      </g>
      <g transform="matrix(1,0,0,1,-75.1883,128.877)">
        <path d="M100.445,44.962L135.671,-8.827L103.749,-58.116L128.077,-58.116L148.749,-24.999L168.999,-58.116L193.116,-58.116L161.054,-8.054L196.281,44.962L171.179,44.962L148.327,9.313L125.406,44.962L100.445,44.962Z"/>
      </g>
    </svg>
  );
}